<template>
  <div class="service-display">
    <VDescriptionListDividedHorizontal>
      <VEntry v-if="showSingleService" name="payment.product_name_headline" :value="productName" mandatory />
      <VEntry v-else v-slot="{ value }" name="payment.product_name_headline" :value="selectedServiceWrapper" mandatory>
        <VSelect v-model="selectedServiceWrapper" name="service" required :placeholder="$t('payment.select_placeholder_service')">
          <option v-for="(service, key) in sortedServices" :key="key" :value="service.id" :selected="value === service.id">
            {{ service.text }}
          </option>
        </VSelect>
      </VEntry>

      <VEntry v-slot="{ value }" :name="productDescriptionHeadline" :value="productDescription" mandatory>
        <span v-html="value" />
      </VEntry>
      <slot></slot>
    </VDescriptionListDividedHorizontal>
  </div>
</template>

<script>
import VDescriptionListDividedHorizontal from '@/components/DescriptionList/DividedHorizontal';
import VEntry from '@/components/DescriptionList/Entry';
import VSelect from '@/components/Form/Select';

export default {
  name: 'ServiceDisplay',

  components: {
    VDescriptionListDividedHorizontal,
    VEntry,
    VSelect,
  },

  model: {
    prop: 'selectedService',
    event: 'change-service',
  },

  props: {
    services: {
      type: Array,
      required: false,
      default: null,
    },
    selectedService: {
      type: String,
      required: true,
      default: '',
    },
  },

  data() {
    return {
      internalValue: this.selectedService,
    };
  },

  computed: {
    productName() {
      const key = `payment.${this.internalValue}_product_name`;
      if (this.$te(key)) return this.$to(key);
      return '';
    },

    productDescription() {
      const key = `payment.${this.internalValue}_product_description`;
      if (this.$te(key)) return this.$to(key);
      return '';
    },

    productDescriptionHeadline() {
      return this.internalValue ? 'payment.product_description_headline' : '';
    },

    showSingleService() {
      return !this.services || this.services.length === 1;
    },

    selectedServiceWrapper: {
      get() {
        return this.internalValue;
      },
      set(value) {
        this.internalValue = value;
        this.$emit('change-service', this.internalValue);
      },
    },

    sortedServices() {
      return this.services
        .map(service => {
          return { id: service, text: this.$to(`payment.${service}_product_name`) };
        })
        .sort((a, b) => (a.text === b.text ? 0 : a.text < b.text ? -1 : 1));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@scss';

.service-display {
  margin-bottom: 6px;
}

@media screen and (min-width: #{$grid-medium-max}px) {
  // because DividedHorizontal is a functional component, we need to set
  // the display: flex in this component
  // TODO: Migrate DividedHorizontal into an own "fully fledged" component?
  .auto-height-container ::v-deep {
    display: flex;

    dl {
      display: flex;
      flex-flow: column;
      height: 100%;

      dd {
        flex-grow: 1;
      }
    }
  }
}
</style>
